import styled from "styled-components";

export const StyledForm = styled.form`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}) {
    grid-template-columns: 1fr;
  }
`;

// export const Input = styled.input`
//   padding: 10px;
//   border: 1px solid ${({ theme }) => theme.color.border};
// `;

export const Button = styled.button`
  color: ${({ theme }) => theme.color.buttonText};
  background: ${({ theme }) => theme.color.taskButton};
  padding: 10px;
  border: none;
  transition: ${({ theme }) => theme.transition.time};

  &:hover {
    filter: brightness(120%);
    transform: scale(1.1);
    cursor: pointer;
  }

  &:active {
    filter: brightness(140%);
  }
`;
